import isAuthenticated from '@/middlewares/isAuthenticated'

export default [
  {
    path: '/project-management',
    name: 'project-management',
    component: () => import('@/views/ProjectManagement/Index.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Project Management',
      breadcrumb: [
        {
          text: 'Project Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid',
    name: 'project-board',
    component: () => import('@/views/ProjectManagement/boards/KanbanBoard.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Kanban Board',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Board',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid/tasks/:taskUid',
    name: 'project-board-task',
    component: () => import('@/views/ProjectManagement/boards/KanbanBoard.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Kanban Board',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Board',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid/milestones/:milestoneUid/tasks',
    name: 'milestone-board',
    component: () => import('@/views/ProjectManagement/boards/KanbanBoard.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Kanban Board',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Milestones',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid/milestones',
    name: 'project-board-milestones',
    component: () => import('@/views/ProjectManagement/milestones/Index.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Milestones',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Board',
          to: { name: 'project-board' },
        },
        {
          text: 'Milestones',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid/milestone/:milestoneUid',
    name: 'project-board-milestone',
    component: () => import('@/views/ProjectManagement/boards/KanbanBoard.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Milestone',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Board',
          to: { name: 'project-board' },
        },
        {
          text: 'Milestones',
          to: { name: 'project-board-milestones' },
        },
        {
          text: 'Milestone',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-management/board/:boardUid/report',
    name: 'project-board-member-report',
    component: () => import('@/views/ProjectManagement/boards/BoardPerformanceReport.vue'),
    meta: {
      middleware: [isAuthenticated],
      pageTitle: 'Performance Report',
      breadcrumb: [
        {
          text: 'Project Management',
          to: { name: 'project-management' },
        },
        {
          text: 'Board',
          to: { name: 'project-board' },
        },
        {
          text: 'Member Performance Report',
          active: true,
        },
      ],
    },
  },
]
